// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2bp5g{display:inline-block;margin-left:15px}._2bp5g,.KoDaX{cursor:pointer;width:40px;height:40px}.KoDaX{display:-ms-inline-flexbox;display:inline-flex;margin-left:4px}._2BqAW{display:block;color:inherit;text-decoration:none}._5oxj4{min-height:36px;margin-left:4px!important;padding:6px 14px!important;border-radius:10px!important;font-size:14.5px!important;font-weight:600!important;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"avatarContainer": "_2bp5g",
	"avatarMobile": "KoDaX",
	"menuLink": "_2BqAW",
	"signIn": "_5oxj4"
};
module.exports = exports;
